/** Intrinsic dimensions from SVG viewBox (width / height). */
export const MASCOT_INTRINSIC = { width: 7278, height: 8695 } as const
export const WORDMARK_INTRINSIC = { width: 7296, height: 3264 } as const
export const HASH_INTRINSIC = { width: 7296, height: 3264 } as const

export function dimensionsFromHeight(
  intrinsic: { width: number; height: number },
  height: number
) {
  const width = Math.round((intrinsic.width / intrinsic.height) * height)
  return { width, height }
}
